module["exports"] = [
  "S.L.",
  "e Hijos",
  "S.A.",
  "Hermanos"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/company/suffix.js
 ** module id = 600
 ** module chunks = 0
 **/